import { Options } from 'qr-code-styling';

export const DEFAULT_QR_OPTIONS: Options = {
  width: 278,
  height: 278,
  image: '/logo.png',
  dotsOptions: {
    color: '#000000',
    type: 'square',
    roundSize: true,
  },
  cornersSquareOptions: {
    color: '#000000',
    type: 'square', // Тип углов (square, extra-rounded, rounded)
  },
  cornersDotOptions: {
    color: '#000000',
    type: 'square', // Тип точек в углах
  },
  backgroundOptions: {
    color: '#ffffff', // Цвет фона
  },
};
